import storage from '@pro/common/dao/storage';
export { WEB2ONEHIK_LANGUAGE_KEY } from '@pro/common/consts/web2onehik-language-key';

export default {
  WANT_TO_URL_KEY: 'goUrl',
  PROBATION: '60',
  VERSION: process.env.buildVersion,
  TRANSLATED_EVZ_CODE: ['EVZ20002', 'EVZ20007', 'EVZ20010', 'EVZ20013', 'EVZ20014', 'EVZ20017'],
  LANGUAGE_DEFAULT: [
    {
      index: 0,
      key: 'en'
    },
    {
      index: 1,
      key: 'it'
    },
    {
      index: 2,
      key: 'es'
    },
    {
      index: 3,
      key: 'de'
    },
    {
      index: 4,
      key: 'fr'
    },
    {
      index: 5,
      key: 'pl'
    },
    {
      index: 6,
      key: 'nl'
    },
    {
      index: 7,
      key: 'bg'
    },
    {
      index: 8,
      key: 'cs'
    },
    {
      index: 9,
      key: 'da'
    },
    {
      index: 10,
      key: 'fi'
    },
    {
      index: 11,
      key: 'hu'
    },
    {
      index: 12,
      key: 'pt'
    },
    {
      index: 13,
      key: 'et'
    },
    {
      index: 14,
      key: 'hr'
    },
    {
      index: 15,
      key: 'el'
    },
    {
      index: 16,
      key: 'no'
    },
    {
      index: 17,
      key: 'lv'
    },
    {
      index: 18,
      key: 'lt'
    },
    {
      index: 19,
      key: 'ro'
    },
    {
      index: 20,
      key: 'ru'
    },
    {
      index: 21,
      key: 'sv'
    },
    {
      index: 22,
      key: 'sl'
    },
    {
      index: 23,
      key: 'sk'
    },
    {
      index: 24,
      key: 'sr'
    },
    {
      index: 25,
      key: 'tr'
    },
    {
      index: 26,
      key: 'uk'
    },
    {
      index: 27,
      key: 'ko'
    },
    {
      index: 28,
      key: 'zh_TW'
    },
    {
      index: 29,
      key: 'th'
    },
    {
      index: 30,
      key: 'vi'
    },
    {
      index: 31,
      key: 'ja'
    },
    {
      index: 32,
      key: 'he'
    },
    {
      index: 33,
      key: 'pt_BR'
    },
    {
      index: 34,
      key: 'ar'
    },
    {
      index: 35,
      key: 'fa'
    },
    {
      index: 36,
      key: 'in'
    },
    {
      index: 37,
      key: 'uz'
    },
    {
      index: 38,
      key: 'kk'
    },
    {
      index: 39,
      key: 'kh'
    },
    {
      index: 40,
      key: 'ku'
    },
    {
      index: 41,
      key: 'ur'
    },
    {
      index: 42,
      key: 'bn'
    },
    {
      index: 43,
      key: 'az'
    }
  ]
};

export const RESOURCE_TYPE = {
  SITE: 0, //站点
  DEVICE: 1, //设备
  CHANNEL: 2, //Camera
  ZONE: 3, //防区
  ACESSORY: 4, //外设
  ALARM_CHANNEL: 5, // 报警通道
  DOOR_BELL: 6, //门铃
  CLOUD_CHANNEL: 7, //云存储
  SWITCH_CHANNEL: 8
};
export const DEVICE_TYPE = {
  UNKNOWN: 0,
  IPC: 1,
  NVR: 2,
  ALARMHOST: 3, //报警主机
  INTERCOM: 4, //对讲设备
  ACCESSCONTROL: 5, //门禁
  ENCODER: 6, //编码
  IPDOME: 7, //球机,
  DOOR_BELL: 8, //门铃
  CLOUDBOX: 9, //云盒子
  THERMAL_CAMERA: 10, //热成像,S
  SWITCH: 11,
  OTHERS: 12 //其他设备
};
export const DEVICE_LOGO = {
  [DEVICE_TYPE.UNKNOWN]: 'icomoon-tree_coding_device',
  [DEVICE_TYPE.IPC]: 'icomoon-tree_coding_device_ipc',
  [DEVICE_TYPE.NVR]: 'icomoon-tree_coding_device',
  [DEVICE_TYPE.ALARMHOST]: 'icomoon-tree_alarm_host',
  [DEVICE_TYPE.INTERCOM]: 'icomoon-tree_video_intercom',
  [DEVICE_TYPE.ACCESSCONTROL]: 'icomoon-tree_access_control_device',
  [DEVICE_TYPE.ENCODER]: 'icomoon-tree_device',
  [DEVICE_TYPE.IPDOME]: 'icomoon-tree_coding_device_speed_dome_camera',
  [DEVICE_TYPE.DOOR_BELL]: 'icomoon-tree_doorbell',
  [DEVICE_TYPE.CLOUDBOX]: 'icomoon-icon_video_cloud_24px',
  [DEVICE_TYPE.THERMAL_CAMERA]: 'icomoon-icon_device_alarm_service_24px',
  [DEVICE_TYPE.SWITCH]: 'icon-icon_site_topology_ac_online',
  [DEVICE_TYPE.OTHERS]: 'icon-icon_other_more_device_x_24'
};

export const DEVICE_ICON_SM = {
  [DEVICE_TYPE.UNKNOWN]: 'icomoon-img_device_unknow',
  [DEVICE_TYPE.IPC]: 'icomoon-tree_coding_device_ipc_nor',
  [DEVICE_TYPE.NVR]: 'icomoon-tree_coding_device_nvr_nor',
  [DEVICE_TYPE.ALARMHOST]: 'icomoon-tree_alarm_host_nor',
  [DEVICE_TYPE.INTERCOM]: 'icomoon-tree_video_intercom_nor',
  [DEVICE_TYPE.ACCESSCONTROL]: 'icomoon-tree_access_control_device_nor',
  [DEVICE_TYPE.ENCODER]: 'icomoon-tree_device_nor',
  [DEVICE_TYPE.IPDOME]: 'icomoon-tree_coding_device_speed_dome_camera_nor',
  [DEVICE_TYPE.DOOR_BELL]: 'icomoon-tree_doorbell_nor',
  [DEVICE_TYPE.CLOUDBOX]: 'icomoon-icon_video_cloud_24px_nor',
  [DEVICE_TYPE.THERMAL_CAMERA]: 'icomoon-icon_device_alarm_service_24px_nor',
  [DEVICE_TYPE.SWITCH]: 'icon-icon_site_topology_ac_online',
  [DEVICE_TYPE.OTHERS]: 'icon-icon_other_more_device_x_24'
};

export const ACCESSORY_TYPE = {
  OUTPUT: 0, //输出模块
  KEYBOARD: 1, //键盘
  LIGHT: 2, //警号
  CARD_READER: 3, //读卡器
  RECEIVE: 4, //接收器
  ZONE_MODEL: 5, //防区模块
  RELAY: 6, //继电器
  REPEATER: 7, // 中继器
  TRANSMITTER: 8,
  ELECTRONIC_FENCE: 11 //电子围栏
};
export const ACCESSORY_LOGO = {
  [ACCESSORY_TYPE.OUTPUT]: 'icomoon-tree_output_module',
  [ACCESSORY_TYPE.KEYBOARD]: 'icomoon-tree_keyboard',
  [ACCESSORY_TYPE.LIGHT]: 'icomoon-tree_warning_signal',
  [ACCESSORY_TYPE.CARD_READER]: 'icomoon-tree_card_reader',
  [ACCESSORY_TYPE.RECEIVE]: 'icomoon-tree_wireless_receiver',
  [ACCESSORY_TYPE.ZONE_MODEL]: 'icomoon-tree_alarm_input',
  [ACCESSORY_TYPE.REPEATER]: 'icomoon-icon_repeater',
  [ACCESSORY_TYPE.TRANSMITTER]: 'icomoon-tree_transmitter',
  [ACCESSORY_TYPE.RELAY]: 'icomoon-relay_details',
  [ACCESSORY_TYPE.ELECTRONIC_FENCE]: 'icon-icon_TF_card_fence'
};

export const CHANNEL_SOURCETYPE_LOGO = {
  [RESOURCE_TYPE.CHANNEL]: 'icomoon-tree_camera', //Camera
  [RESOURCE_TYPE.ZONE]: 'icomoon-tree_alarm_input', //防区
  [RESOURCE_TYPE.ALARM_CHANNEL]: 'icomoon-tree_camera', //报警通道
  [RESOURCE_TYPE.DOOR_BELL]: 'icomoon-tree_camera', //门铃通道
  [RESOURCE_TYPE.CLOUD_CHANNEL]: 'icomoon-tree_camera',
  [RESOURCE_TYPE.SWITCH_CHANNEL]: 'icomoon-img_switch_electrical_24px'
};

export const SITE_TRANSFER_STATUS = {
  UNTRANSFER: 0,
  USER_NOT_REGISTED: 1,
  USER_NOT_ACCEPTED: 2,
  TRANSFERED: 3
};

export const COMMON_TABLE = {};
export const SPECIAL_TABLE = {
  39: {
    lang: ['en'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/VAT Number|Vat Number|VAT No.|VAT number/g, 'ABN');
    }
  },
  143: {
    lang: ['es', 'en'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/VAT Number|Vat Number|VAT number|VAT No.|número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'VAT Number': 'RFC Number',
          'VAT number': 'RFC number',
          'Vat Number': 'RFC Number',
          'VAT No.': 'RFC No.',
          'número NIF': 'número RFC',
          'n.º NIF': 'n.º RFC',
          NIF: 'RFC',
          'NIF válido': 'RFC válido'
        }[$0];
      });
    }
  },
  172: {
    lang: [],
    proxy: {
      ...COMMON_TABLE,
      syscom_login_tip: 'ep_login_tip'
    },
    valueProxy: (val) => {
      return val.replace(
        /Номер плательщика НДС|номер плательщика НДС|номера плательщика НДС|№ плательщика НДС|support@hikvision.com/g,
        ($0) => {
          return {
            'Номер плательщика НДС': 'ИНН',
            'номер плательщика НДС': 'ИНН',
            'номера плательщика НДС': 'ИНН',
            '№ плательщика НДС': 'ИНН',
            'support@hikvision.com': 'HPC_RUS@hikvision.com'
          }[$0];
        }
      );
    }
  },
  593: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'Número RUC',
          'n.º NIF': 'n.º RUC',
          NIF: 'RUC',
          'NIF válido': 'RUC válido'
        }[$0];
      });
    }
  },
  210: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'número RUT',
          'n.º NIF': 'n.º RUT',
          NIF: 'RUT',
          'NIF válido': 'RUT válido'
        }[$0];
      });
    }
  },
  167: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'número RUC',
          'n.º NIF': 'n.º RUC',
          NIF: 'RUC',
          'NIF válido': 'RUC válido'
        }[$0];
      });
    }
  },
  168: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'número RUC',
          'n.º NIF': 'n.º RUC',
          NIF: 'RUC',
          'NIF válido': 'RUC válido'
        }[$0];
      });
    }
  },
  34: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'número CUIT',
          'n.º NIF': 'n.º CUIT',
          NIF: 'CUIT',
          'NIF válido': 'CUIT válido'
        }[$0];
      });
    }
  },
  67: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'número NIT',
          'n.º NIF': 'n.º NIT',
          NIF: 'NIT',
          'NIF válido': 'NIT válido'
        }[$0];
      });
    }
  },
  66: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'número RUT',
          'n.º NIF': 'n.º RUT',
          NIF: 'RUT',
          'NIF válido': 'RUT válido'
        }[$0];
      });
    }
  },
  77: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/número NIF|n.º NIF|NIF|NIF válido/g, ($0) => {
        return {
          'número NIF': 'número RNC',
          'n.º NIF': 'n.º RNC',
          NIF: 'RNC',
          'NIF válido': 'RNC válido'
        }[$0];
      });
    }
  },
  165: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/NIF/g, ($0) => {
        return {
          NIF: 'RUC'
        }[$0];
      });
    }
  },
  214: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/NIF/g, ($0) => {
        return {
          NIF: 'RIF'
        }[$0];
      });
    }
  },
  72: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/NIF/g, ($0) => {
        return {
          NIF: 'Cédula jurídica'
        }[$0];
      });
    }
  },
  157: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/NIF/g, ($0) => {
        return {
          NIF: 'RUC'
        }[$0];
      });
    }
  },
  103: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/NIF/g, ($0) => {
        return {
          NIF: 'RTN'
        }[$0];
      });
    }
  },
  81: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/NIF/g, ($0) => {
        return {
          NIF: 'NIT'
        }[$0];
      });
    }
  },
  98: {
    lang: ['es'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/NIF/g, ($0) => {
        return {
          NIF: 'NIT'
        }[$0];
      });
    }
  },
  54: {
    lang: ['pt_BR'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/IVA|VAT/g, ($0) => {
        return {
          IVA: 'CPNJ',
          VAT: 'CPNJ'
        }[$0];
      });
    }
  },
  117: {
    lang: ['ko'],
    proxy: {
      ...COMMON_TABLE
    },
    valueProxy: (val) => {
      return val.replace(/VAT/g, ($0) => {
        return {
          VAT: '사업자'
        }[$0];
      });
    }
  }
};
export const VERSION_TABLE = {
  NEUTRAL: {
    copyright: '',
    'HPP-web_invite_noregist_tip1_msg': 'HPP-web_invite_noregist_tip1_neutral_msg',
    'HPP-web_invite_noregist_tip2_msg': 'HPP-web_invite_noregist_tip2_neutral_msg',
    arc_supported_devices_tip: 'arc_supported_devices_tip_neutral',
    no_arc_devices: 'no_arc_devices_neutral',
    device_oem: 'device_oem_neutral',
    LAP006041: 'device_oem_neutral',
    LAP006042: 'device_oem_neutral',
    LAP020017: 'device_oem_neutral',
    dip_status_7: 'device_oem_neutral',
    device_oem_unknown: 'device_oem_neutral',
    arc_supported_devices_tip_hub: 'arc_supported_devices_tip_hub_neutral',
    arc_supported_devices_tip_all_security: 'arc_supported_devices_tip_all_security_neutral',
    no_arc_devices_hub: 'no_arc_devices_hub_neutral',
    no_arc_devices_all_security: 'no_arc_devices_all_security_neutral',
    EVZ20013: 'EVZ20013_neutral'
  }
};
// HC定制版的多语言key替换表
export const HC_OEM_TABLE = {
  EVZ20013: 'EVZ20013_neutral'
};
export function isShowEP() {
  const upgradeStrategyMap = JSON.parse(storage.realGet('hpp_upgrade_strategy'));
  const country = storage.realGet(storage.NAME.SELECT_COUNTRY);
  return upgradeStrategyMap?.[country]?.showEpWord;
}
export const TRANSLATE_HANDLER = function (key, LANGUAGE_OPTIONS) {
  let curLang = 'en';
  for (let i = 0; i < LANGUAGE_OPTIONS.length; i++) {
    if (LANGUAGE_OPTIONS[i].key === parseInt(localStorage.getItem('hik_connect_pro_locale'), 10)) {
      curLang = LANGUAGE_OPTIONS[i].key;
      break;
    }
  }
  //获取当前国家
  const curCountry = localStorage.getItem('hik_connect_pro_country');
  const obj = SPECIAL_TABLE[curCountry];
  const table = obj ? (obj?.lang.includes(curLang) ? obj.proxy : COMMON_TABLE) : COMMON_TABLE;
  key = table[key] ? table[key] : key;
  if (process.env.appmode !== 'NORMAL' && VERSION_TABLE[process.env.appmode]) {
    key = Object.hasOwnProperty.call(VERSION_TABLE[process.env.appmode], key)
      ? VERSION_TABLE[process.env.appmode][key]
      : key;
  }
  if (window.HC_OEM_VERSION) {
    key = Object.hasOwnProperty.call(HC_OEM_TABLE, key) ? HC_OEM_TABLE[key] : key;
  }
  return key;
};

// web多语言key对应的app多语言key
export const WEB2APP_LANGUAGE_KEY = {
  ar: 'ar',
  az: 'az',
  bg: 'bg',
  bn: 'bn',
  cs: 'cs',
  da: 'da',
  de: 'de',
  el: 'el',
  en: 'en',
  es: 'es',
  et: 'et',
  fa: 'fa',
  fi: 'fi',
  fr: 'fr',
  he: 'he',
  hr: 'hr',
  hu: 'hu',
  in: 'id', //India
  it: 'it',
  ja: 'ja',
  kh: 'kh',
  kk: 'kk',
  ko: 'ko',
  lt: 'lt',
  lv: 'lv',
  no: 'nb', // APP:Norwegian Bokmal \ WEB:Norway
  nl: 'nl',
  pl: 'pl',
  pt_BR: 'ptBR',
  pt: 'pt',
  ro: 'ro',
  ru: 'ru',
  sk: 'sk',
  sl: 'sl',
  sr: 'sr',
  sv: 'sv',
  th: 'th',
  tr: 'tr',
  uk: 'uk',
  ur: 'ur',
  uz: 'uz',
  vi: 'vi',
  zh_TW: 'zhHant'
};

export const TRANSLATE_VALUE = (ParamValue, LANGUAGE_OPTIONS) => {
  let curLang = 'en';
  let value = ParamValue;
  for (let i = 0; i < LANGUAGE_OPTIONS.length; i++) {
    if (LANGUAGE_OPTIONS[i].index === parseInt(localStorage.getItem('hik_connect_pro_locale'), 10)) {
      curLang = LANGUAGE_OPTIONS[i].key;
      break;
    }
  }
  if (!isShowEP()) {
    //配置国家是否显示ePartner
    value = value.replace(/OneHikID \(Hik-ePartner\)/g, 'OneHikID');
    value = value.replace(/OneHikID\(Hik-ePartner\)/g, 'OneHikID');
  }
  const curCountry = localStorage.getItem('hik_connect_pro_country');
  if (!SPECIAL_TABLE[curCountry]?.lang?.length && SPECIAL_TABLE[curCountry]?.lang?.length === 0) {
    //如果SPECIAL_TABLE[curCountry].lang为空数组，所有的语言都会进行替换
    const allCountry = Object.keys(WEB2APP_LANGUAGE_KEY).concat(['zh_CN']);
    return SPECIAL_TABLE[curCountry] && allCountry.includes(curLang)
      ? SPECIAL_TABLE[curCountry].valueProxy
        ? SPECIAL_TABLE[curCountry].valueProxy(value)
        : value
      : value;
  }

  return SPECIAL_TABLE[curCountry] && SPECIAL_TABLE[curCountry]?.lang.includes(curLang)
    ? SPECIAL_TABLE[curCountry].valueProxy
      ? SPECIAL_TABLE[curCountry].valueProxy(value)
      : value
    : value;
};
export const COMPANY_TYPE = {
  INSTALLER: 0, //安装商
  SYSTEM_INTEGRATOR: 1, //系统集成商
  ARC: 2, //接警中心
  END_USER: 3, //终端用户
  IT_STAFF: 4, //IT人员
  OTHERS: 5, //其他
  DISTRIBUTOR: 6 // 分销商
};

export const ARC_COMPANY_STATUS = {
  NOT_HAVE_API_KEY: 0, //公司已经完成认证 但是没产生api key
  HAVE_API_KEY_NOT_COMPLETE_INFO: 1, //已经申请 产生了api key 但是没申请入驻(未完善信息)
  REVIEW_ING: 2, //已经申请入驻 待待审核状态  审核中
  REVIEW_SUCCESS: 3, //已经申请入驻 审核完成 成功通过
  REVIEW_FAIL: 4, //已经申请入驻 审核完成 失败
  HAVE_API_KEY_COMPLETE_INFO: 5, //已经申请 产生了api key 但是没申请入驻(完善了信息)
  COMPANY_INFO_VERIFY: 6 // 公司信息未通过审核（后端目前没有这个返回）
};

export const INSTALLER_SECOND_PERMISSION = {
  REMOTE_CONFIG: '10',
  VIDEO_PREVIEW: '11',
  VIDEO_PLAYBACK: '12',
  AXPRO_DEPLOYMENT: '13',
  AXPRO_DISARM: '14',
  AXPRO_BYPASS: '15',
  USER_KEYBOARD_PASSWORD: '16',
  BATCH_INVITE_HC_ACCOUNT: '17',
  AXPRO_REMOTE_CONFIG: '18',
  AXPRO_VIEW_LOG: '19',
  AXPRO_CREATE_LOCAL_USERS: '20',
  AXPRO_OUTPUT_CONTROL: '21',
  AXECO_USER_MANAGEMENT: '22',
  AXECO_SYSTEM_MANAGEMENT: '23',
  AXECO_AREAS: '24',
  USER_MANAGEMENT: '25',
  LOCAL_USER_MANAGEMENT: '26',
  CLOUD_USER_MANAGEMENT: '27',
  KEYPAD_CODE_MANAGEMENT: '16',
  SYSTEM_MANAGEMENT: '28',
  NOTIFICATION_SETTINGS_MANAGEMENT: '29',
  PANEL_SETTINGS_MANAGEMENT: '30',
  PERIPHERALS_SETTINGS_MANAGEMENT: '31',
  AREAS_SETTINGS_MANAGEMENT: '32',
  PRIVACY_SETTING_MANAGEMENT: '33',
  ADVANCED_SETTINGS_MANAGEMENT: '34',
  AUTOMATION_DEVICES_CONTROL: '35',
  TAP_2_RUN: '36',
  HAND_OVER: '37',
  // ARC_MANAGEMENT: '38',
  DELETE: '39',
  PIRCAM: '40'
};

export const ALWAYS_ON_INSTALLER_SECOND_PERMISSION = [
  INSTALLER_SECOND_PERMISSION.AXPRO_VIEW_LOG
];

export const MAP_TYPE = {
  COMPANY: 0,
  SINGLE_SITE: 1,
  MUTI_SITE: 2
};

export const MAP_MARKER_TYPE = {
  COMPANY: 0, // 公司类型
  USER_LOCALE: 1, // 用户本地地址
  USER_CLICK: 2, // 用户点击
  CONFIG_SITE: 3, // 已配置的站点
  HEALTH_SITE: 4, // 健康监测站点
  NORMAL_SITE: 5 // 普通站点
};

//arc子权限枚举
export const ARC_SUB_PERM_TYPE = {
  PIRCAM_GIF: 10,
  VIDEO_CLIPS: 11,
  PANIC_ALARM: 12,
  MEDICAL_ALARM: 13,
  FIRE_ALARM: 14,
  SMART_ALARM: 15,
  PANEL_TAMPER: 16,
  EXTERNAL_DEVICE_TAMPER: 17,
  ZONE_ALARM: 18,
  PANEL_OPERATION: 19,
  PANEL_POWER_STATUS: 21,
  PANEL_COMMUNICATE_STATUS: 22,
  ZONE_STATUS: 23,
  EXTERNAL_DEVICE_STATUS: 24,
  //eco
  ALARMS: 5,
  FAULTS: 6,
  OPERATIONS: 7,
  SYSTEM_EVENTS: 8,
  PIRCAM_GIF_ECO: 9
};

export const ARC_SUB_PERM_ALARMS_TYPE = {
  //报警2.0
  ALARMS: 39,
  FAULTS: 40,
  OPERATIONS: 41,
  SYSTEM_EVENTS: 42,
  ZONE_ALARM: 18,
  PERIPHERAL_TAMPER: 17,
  PANEL_LID_OPENED: 16,
  KEYPAD_KEYFOD_APP_PANIC_ALARM: 12,
  KEYPAD_KEYFOD_MEDICAL_ALARM: 13,
  KEYPAD_FIRE_ALARM: 14,
  CAMERA_EVENTS: 15,
  PIRCAM_GIF: 10,
  VIDEO_CLIPS: 11,
  PANEL_STATUS_POWER_AND_BATTERY: 21,
  PANEL_STATUS_COMMUNICATIONS: 22,
  ZONE_STATUS: 23,
  PERIPHERALS_STATUS: 24,
  SYSTEM_OPERATIONS: 19,
  PANEL_UPGRADE: 45
};
//arc子权限多语言key , 对象key值顺序与设备一致
export const ARC_SUB_PERM_SEQUENCE = [
  ARC_SUB_PERM_TYPE.ZONE_ALARM,
  ARC_SUB_PERM_TYPE.EXTERNAL_DEVICE_TAMPER,
  ARC_SUB_PERM_TYPE.PANEL_TAMPER,
  ARC_SUB_PERM_TYPE.PANIC_ALARM,
  ARC_SUB_PERM_TYPE.MEDICAL_ALARM,
  ARC_SUB_PERM_TYPE.FIRE_ALARM,
  ARC_SUB_PERM_TYPE.PANEL_POWER_STATUS,
  ARC_SUB_PERM_TYPE.PANEL_COMMUNICATE_STATUS,
  ARC_SUB_PERM_TYPE.ZONE_STATUS,
  ARC_SUB_PERM_TYPE.EXTERNAL_DEVICE_STATUS,
  ARC_SUB_PERM_TYPE.PANEL_OPERATION,
  ARC_SUB_PERM_TYPE.SMART_ALARM,
  ARC_SUB_PERM_TYPE.PIRCAM_GIF,
  ARC_SUB_PERM_TYPE.VIDEO_CLIPS
];

export const ARC_AX_PRO_PERM_NAME = {
  [ARC_SUB_PERM_TYPE.ZONE_ALARM]: 'HPP-web_arc_sub_zone_alarm_name',
  [ARC_SUB_PERM_TYPE.EXTERNAL_DEVICE_TAMPER]: 'HPP-web_arc_sub_external_device_tamper_name',
  [ARC_SUB_PERM_TYPE.PANEL_TAMPER]: 'HPP-web_arc_sub_panel_tamper_name',
  [ARC_SUB_PERM_TYPE.PANIC_ALARM]: 'HPP-web_arc_sub_panic_alarm_name',
  [ARC_SUB_PERM_TYPE.MEDICAL_ALARM]: 'HPP-web_arc_sub_medical_alarm_name',
  [ARC_SUB_PERM_TYPE.FIRE_ALARM]: 'HPP-web_arc_sub_fire_alarm_name',
  [ARC_SUB_PERM_TYPE.PANEL_POWER_STATUS]: 'HPP-web_arc_sub_panel_power_status_name',
  [ARC_SUB_PERM_TYPE.PANEL_COMMUNICATE_STATUS]: 'HPP-web_arc_sub_panel_communicate_status_name',
  [ARC_SUB_PERM_TYPE.ZONE_STATUS]: 'HPP-web_arc_sub_zone_status_name',
  [ARC_SUB_PERM_TYPE.EXTERNAL_DEVICE_STATUS]: 'HPP-web_arc_sub_external_device_status_name',
  [ARC_SUB_PERM_TYPE.PANEL_OPERATION]: 'HPP-web_arc_sub_panel_operation_name',
  [ARC_SUB_PERM_TYPE.SMART_ALARM]: 'HPP-web_arc_sub_camera_events_name',
  [ARC_SUB_PERM_TYPE.PIRCAM_GIF]: 'HPP-web_arc_sub_pircam_video_picture_name',
  [ARC_SUB_PERM_TYPE.VIDEO_CLIPS]: 'HPP-web_arc_sub_ipc_video_picture_name',
  [ARC_SUB_PERM_TYPE.ALARMS]: 'HPP-web_arc_sub_alarms_name',
  [ARC_SUB_PERM_TYPE.FAULTS]: 'HPP-web_arc_sub_faults_name',
  [ARC_SUB_PERM_TYPE.OPERATIONS]: 'HPP-web_arc_sub_operations_name',
  [ARC_SUB_PERM_TYPE.SYSTEM_EVENTS]: 'HPP-web_arc_sub_system_events_name',
  [ARC_SUB_PERM_TYPE.PIRCAM_GIF_ECO]: 'HPP-web_arc_sub_pircam_video_picture_name'
};

export const ARC_AX_PRO_2_PERM_NAME = {
  [ARC_SUB_PERM_ALARMS_TYPE.ALARMS]: 'HPP-web_arc_sub_alarms_name',
  [ARC_SUB_PERM_ALARMS_TYPE.FAULTS]: 'HPP-web_arc_sub_faults_name',
  [ARC_SUB_PERM_ALARMS_TYPE.OPERATIONS]: 'HPP-web_arc_sub_operations_name',
  [ARC_SUB_PERM_ALARMS_TYPE.SYSTEM_EVENTS]: 'HPP-web_arc_sub_system_events_name',
  [ARC_SUB_PERM_ALARMS_TYPE.ZONE_ALARM]: 'HPP-web_arc_sub_zone_alarm_name',
  [ARC_SUB_PERM_ALARMS_TYPE.PERIPHERAL_TAMPER]: 'HPP-web_arc_sub_peripheral_tamper_name',
  [ARC_SUB_PERM_ALARMS_TYPE.PANEL_LID_OPENED]: 'HPP-web_arc_sub_panel_tamper_name',
  [ARC_SUB_PERM_ALARMS_TYPE.KEYPAD_KEYFOD_APP_PANIC_ALARM]: 'HPP-web_arc_sub_keypad_keyfod_APP_panic_alarm_name',
  [ARC_SUB_PERM_ALARMS_TYPE.KEYPAD_KEYFOD_MEDICAL_ALARM]: 'HPP-web_arc_sub_medical_alarm_name',
  [ARC_SUB_PERM_ALARMS_TYPE.KEYPAD_FIRE_ALARM]: 'HPP-web_arc_sub_fire_alarm_name',
  [ARC_SUB_PERM_ALARMS_TYPE.CAMERA_EVENTS]: 'HPP-web_arc_sub_camera_events_name',
  [ARC_SUB_PERM_ALARMS_TYPE.PIRCAM_GIF]: 'HPP-web_arc_sub_pircam_video_picture_name',
  [ARC_SUB_PERM_ALARMS_TYPE.VIDEO_CLIPS]: 'HPP-web_arc_sub_ipc_video_picture_name',
  [ARC_SUB_PERM_ALARMS_TYPE.PANEL_STATUS_POWER_AND_BATTERY]: 'HPP-web_arc_sub_panel_status_power_and_battery_name',
  [ARC_SUB_PERM_ALARMS_TYPE.PANEL_STATUS_COMMUNICATIONS]: 'HPP-web_arc_sub_panel_status_communicationsy_name',
  [ARC_SUB_PERM_ALARMS_TYPE.ZONE_STATUS]: 'HPP-web_arc_sub_zone_status_name',
  [ARC_SUB_PERM_ALARMS_TYPE.PERIPHERALS_STATUS]: 'HPP-web_arc_sub_peripherals_status_name',
  [ARC_SUB_PERM_ALARMS_TYPE.SYSTEM_OPERATIONS]: 'HPP-web_arc_sub_system_operations_name',
  [ARC_SUB_PERM_ALARMS_TYPE.PANEL_UPGRADE]: 'HPP-web_arc_sub_panel_upgrade_name'
};
// arc权限
export const ARC_DEVICE_CONTENT = [
  { code: 1, message: 'HPP-web_arc_device_1_tips_msg' },
  { code: 2, message: 'HPP-web_arc_device_2_tips_msg' },
  { code: 3, message: 'HPP-web_arc_device_3_tips_msg' },
  { code: 4, message: 'HPP-web_arc_device_4_tips_msg' },
  { code: 5, message: 'HPP-web_arc_device_5_tips_msg' },
  { code: 6, message: 'HPP-web_arc_device_6_tips_msg' },
  { code: 7, message: 'HPP-web_arc_device_7_tips_msg' },
  { code: 9, message: 'HPP-web_arc_device_9_tips_msg' },
  { code: 10, message: 'HPP-web_arc_device_10_tips_msg' },
  { code: 11, message: 'HPP-web_arc_device_11_tips_msg' },
  { code: 12, message: 'HPP-web_arc_device_12_tips_msg' },
  { code: 13, message: 'HPP-web_arc_device_13_tips_msg' },
  { code: 14, message: 'HPP-web_arc_device_14_tips_msg' },
  { code: 15, message: 'HPP-web_arc_device_15_tips_msg' },
  { code: 16, message: 'HPP-web_arc_device_16_tips_msg' },
  { code: 17, message: 'HPP-web_arc_device_17_tips_msg' }
];
